import React from 'react'
import CellRender from '../cell-render'
import { ContextType, DataType } from '../types/advanced-grid.types'
import { withGridContext } from '../providers'
import { CheckBoxField } from '@app-soga/forms'
import ActionsRenderer from '../actions-renderer'

interface Props {
    rowData?: DataType
    rowKey: number
}

/**
 * Renders a group of cells for the body including the actions cell
 * @author Alejandro Quiroz <alejandro.devop@gmail.com>
 * @version 1.0.0
 * @param param0
 * @returns
 */
const RowRender: React.FC<Props & ContextType> = ({
    actions,
    columns,
    columnKeys,
    config,
    events,
    gridId,
    rowControl,
    rowControlOptions,
    rowData,
    rowKey,
    selectedRecords
}) => {
    const { handleSelectRecord } = events || {}
    const { allowSelect } = config || {}
    const recordId = rowData ? rowData.id : '0'
    return (
        <tr>
            {rowControl && rowData && (
                <td className={`width-10 ${rowControlOptions ? rowControlOptions.className : ''}`}>
                    {rowControl(rowData)}
                </td>
            )}
            {allowSelect && (
                <td className="width-10 text-center">
                    <CheckBoxField
                        id={`${gridId}-row-${recordId}`}
                        checked={
                            selectedRecords &&
                            selectedRecords.includes(parseInt(recordId.toString(), 10))
                        }
                        onChange={() => (handleSelectRecord ? handleSelectRecord(recordId) : null)}
                    />
                </td>
            )}
            <th scope="row">{recordId}</th>
            {columnKeys &&
                columnKeys.map((column, key) => (
                    <CellRender
                        rowData={rowData}
                        columnName={column}
                        columnsConfig={columns || []}
                        key={`col-${rowKey}-${key}`}
                    />
                ))}
            {Boolean(actions) && Array.isArray(actions) && actions.length > 0 && (
                <td className="flex justify-center">
                    <ActionsRenderer rowKey={rowKey} rowData={rowData} />
                </td>
            )}
        </tr>
    )
}

RowRender.defaultProps = {
    selectedRecords: [],
    rowControlOptions: {}
}

export default withGridContext(RowRender)
